





































































import { getCurrentInstance, PropType, ref } from 'vue';
import DocumentPreviewTable from './DocumentPreviewTable.vue';
import { SecureDocumentModel } from '../../../shared/models/secureDocument.model';
import { documentService } from '../../../shared/services/api/document.service';
import { errorSubCodeTypes } from '../../../shared/enums/errorSubCodeTypes.js';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import Icon from '../../../shared/components/Icon.vue';
import { useEsdhExport } from '../../composables/documents/useEsdhExport';
import { useDrawer } from '../../../shared/composables/useDrawer';
import { useSpinner } from '../../../shared/composables/useSpinner';
import { useToast } from '../../../shared/composables/useToast';

export default {
  components: { Icon, DocumentPreviewTable },
  props: {
    selectedDocuments: {
      type: Array as PropType<SecureDocumentModel[]>,
      default: () => [],
    },
    recipientSystemName: {
      type: String,
      default: '',
    },
  },
  emits: ['remove', 'sent'],
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const {
      addDocument,
      clearAll,
      validateCaseReferences,
      prepareCreateEsdhExportJobRequests,
      selectedDocuments: esdhSelectedDocuments,
    } = useEsdhExport();
    const { isVisible, handleVisibilityChange, show, hide } = useDrawer();
    const { isLoading, start, stop } = useSpinner();
    const { showSuccess, showError } = useToast();

    const warningModalRef = ref(null);
    const initialEsdhData = ref(null);

    const populateFromDocuments = () => {
      clearAll();
      props.selectedDocuments.forEach(document => {
        addDocument(document);
      });
      initialEsdhData.value = JSON.stringify(esdhSelectedDocuments);
    };

    const handleDrawerChange = async (value: boolean) => {
      const currentData = JSON.stringify(esdhSelectedDocuments);
      if (!value && currentData !== initialEsdhData.value) {
        const isConfirmed = await proxy.$confirmAction(proxy.$t('warning.discard_changes_warning').toString());
        if (isConfirmed) {
          confirmClose();
        }
        return;
      }
      handleVisibilityChange(value);
    };

    const confirmClose = () => {
      hide();
      clearAll();
      initialEsdhData.value = null;
    };

    const handleSendClicked = () => {
      if (validateCaseReferences()) {
        warningModalRef.value.show();
      }
    };

    const exportDocumentsToEsdh = async () => {
      start();
      warningModalRef.value.hide();
      try {
        const payload = prepareCreateEsdhExportJobRequests();
        await Promise.all(payload.map(request => documentService.exportDocumentsToEsdh(request)));
        showSuccess(proxy.$t('warning.success_esdh_export', { systemName: props.recipientSystemName }).toString());
        emit('sent');
      } catch (error) {
        const subCode = error?.data?.status?.subCode;
        const errorMessage =
          subCode === errorSubCodeTypes.canNotExportDocumentsFromMultipleDifferentMunicipalities
            ? proxy.$t('error.api_error_esdh_export')
            : proxy.$t('error.api_error_generic');
        showError(errorMessage.toString());
      } finally {
        hide();
        stop();
      }
    };

    return {
      iconClassEnum,
      isVisible,
      isLoading,
      warningModalRef,
      handleDrawerChange,
      show,
      hide,
      populateFromDocuments,
      handleSendClicked,
      exportDocumentsToEsdh,
    };
  },
  computed: {
    headerTitle() {
      return this.$t('document.journalise_to_system', { system: this.recipientSystemName });
    },
  },
  methods: {
    onRemove(documentId: number) {
      this.$emit('remove', documentId);
    },
  },
};
